// ------------------------------------------------------------
// Project permission labels — business-friendly names for admin UI
// Backend: use/run = open + run simulation; edit = full design access
// ------------------------------------------------------------

export type AssignablePermission = 'use' | 'edit';

export function toApiPermission(level: AssignablePermission): 'run' | 'edit' {
  return level === 'use' ? 'run' : 'edit';
}

export function fromApiPermission(permission: string): AssignablePermission | 'view' {
  if (permission === 'edit') return 'edit';
  if (permission === 'run' || permission === 'use') return 'use';
  return 'view';
}

export function permissionLabel(permission: string): string {
  switch (permission) {
    case 'edit':
      return 'Edit';
    case 'run':
    case 'use':
      return 'Use';
    case 'view':
      return 'View only';
    default:
      return permission;
  }
}

export function permissionDescription(level: AssignablePermission): string {
  return level === 'use'
    ? 'Open the project and run simulations (read-only design)'
    : 'Full access to edit layout, nodes, and routes';
}
